import { oc } from "@orpc/contract";
import { z } from "zod";

export const SentryTestResponseSchema = z.object({
  captured: z.boolean(),
});

export const sentryTestContract = oc
  .output(SentryTestResponseSchema)
  .route({ method: "POST" });

export const qaContracts = {
  sentryTest: sentryTestContract,
};

export type SentryTestResponse = z.infer<typeof SentryTestResponseSchema>;
